//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('prodGrpLangs', {
//        templateUrl: 'views/components/views/prodGrpLangs/prodGrpLangs.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'prodGrpLangsService', function ($stateParams, stateService, prodGrpLangsService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let prodGrpId = $stateParams.prodgrp_id;

//            vm.model = {
//                inputListLanguages: [],
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALL

//            async function loadLanguages() {
//                vm.model.inputListLanguages = await prodGrpLangsService.listLanguages({ prodgrp_id: prodGrpId });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALL

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                prodGrpLangsService.saveObj({ records: vm.model.inputListLanguages }).then(function () {
//                    vm.model.lockedSave = false;
//                    stateService.back();
//                }, function () {
//                    vm.model.lockedSave = false;
//                });
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//            	loadLanguages();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
